import { isWithinLastMinutes } from '@helpers/date-time.helper';
import QueryTransaction, { ITransaction, TransactionsResponse } from '@interfaces/transaction';

import { get, put } from './api.service';
import { URL_TRANSACTION, URL_TRANSACTION_DETAIL_BY_MASTERID, URL_TRANSACTION_REFUND_BY_MASTERID } from '@constants/api.constants';
import { POS_DEFAULT_OPTION } from '@constants/pos.constants';
import { RECENT_TXN_LIMIT_MIN, ALL } from '@constants/transaction.constants';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';

export const getTransactions = (query: QueryTransaction): Promise<TransactionsResponse> => {
	const params = { ...query };
	if (params?.posId === POS_DEFAULT_OPTION.value) {
		delete params.posId;
	}

	if (params?.type && params.type === ALL) {
		delete params.type;
	}

	return get(URL_TRANSACTION, { params }).then((res: TransactionsResponse) => {
		res.data = res.data.map((transaction: ITransaction) => ({
			...transaction,
			isNew: isWithinLastMinutes(DateTime.fromISO(transaction.createdAt), RECENT_TXN_LIMIT_MIN),
		}));
		return res;
	});
};

export const getTransactionByMasterId = ({ masterId }: { masterId: string }) => {
	const endpoint = `${URL_TRANSACTION_DETAIL_BY_MASTERID}/${masterId}`;
	return get(endpoint);
};

export const updateTransactionMerchantRefIdByMasterId = async ({ masterId, refId }: { masterId: string; refId: string }) => {
	const endpoint = `${URL_TRANSACTION_DETAIL_BY_MASTERID}/${masterId}`;
	return (await put(endpoint, { refId })) as AxiosResponse & { status: string; code?: string };
};

export const refundTransaction = async (masterId: string, amount: number) => {
	const endpoint = `${URL_TRANSACTION_REFUND_BY_MASTERID}/master-id/${masterId}/refund`;
	return (await put(endpoint, { amount: amount })) as AxiosResponse & { masterId: string; status: string; code?: string };
};
